module.exports = __webpack_public_path__ + "img/sixpackcarrier00.3f2e9e47.jpg";